// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3bmbg","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2rR8J"};